/** @jsxImportSource @emotion/react */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import CustomDialog from 'components/modals/common/CustomDialog';
import _ from 'lodash';
import { getMpMcrcPopUpList } from 'apis/mp/MpMcrc';
import CustomGrid from 'components/grids/CustomGrid';
import { SubTitleLayout, SubTitleGroup } from 'components/layouts/ContentLayout';
import { useMessageBar } from 'hooks/useMessageBar';
import { MpMcrcList, SearchParam } from 'models/mp/MpMcrc';
import { useTranslation } from 'react-i18next';

/**
 * 분과위원 조회 팝업
 */

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  condition: any;
}

const MpMcrcPopUp = ({ open, close, condition }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const initSearchParam = {
    mpClsfType: '',
    prdnProcCode: '',
  };

  const [searchParam, setSearchParam] = useState<SearchParam>(initSearchParam);
  const [searchState, setSearchState] = useState<boolean>(false);

  const gridRef = useRef<any>();

  const [rowData, setRowData] = useState<MpMcrcList[]>([]);

  useEffect(() => {
    setSearchParam({
      mpClsfType: condition?.mpClsfType || '',
      prdnProcCd: condition?.prdnProcCode || '',
    });
    setSearchState(true);
  }, [condition?.prdnProcCd, condition?.mpClsfType]);

  useEffect(() => {
    if (searchState) {
      getMpMcrcList();
    }
  }, [searchState]);

  const getMpMcrcList = () => {
    getMpMcrcPopUpList(searchParam).then((result: MpMcrcList[]) => {
      if (result !== null) {
        setRowData(result);
      } else {
        openMessageBar({
          type: 'error',
          content: t(
            'com.msg.요청 정보 조회 중 오류가 발생했습니다.',
            '요청 정보 조회 중 오류가 발생했습니다.'
          ),
        });
        return false;
      }
    });
  };

  const onInitialized = (grid) => {
    gridRef.current = grid;
  };

  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'mpClsfTypeNm',
        header: String(t('mp.label.분류', '분류')),
        width: 120,
        align: 'center',
      },
      {
        binding: 'prdnProcCdNm',
        header: String(t('mp.label.공정', '공정')),
        width: 120,
        align: 'center',
      },
      {
        binding: 'mcrcId',
        header: String(t('mp.label.분과위원ID', '분과위원ID')),
        width: 120,
        align: 'center',
      },
      {
        binding: 'mcrcNm',
        header: String(t('com.label.분과위원명', '분과위원명')),
        width: 120,
        align: 'center',
      },
      {
        binding: 'deptNm',
        header: String(t('com.label.부서명', '부서명')),
        width: '*',
        align: 'left',
      },
    ];
  }, [rowData]);

  const handleClose = () => {
    close();
  };

  return (
    <>
      <CustomDialog
        title={t('mp.label.분과위원 List', '분과위원 List')}
        open={open}
        onClose={handleClose}
        // onCancel={handleClose}
        size="md"
      >
        <SubTitleLayout>
          <SubTitleGroup>
            <h3>{t('mp.label.분과위원 List', '분과위원 List')}</h3>
            <span className="total">
              {t('com.label.총', '총')}
              <span>{rowData?.length ?? 0}</span>
              {t('com.label.건', '건')}
            </span>
          </SubTitleGroup>
        </SubTitleLayout>
        <CustomGrid
          layoutDefinition={layoutDefinition}
          rowData={rowData}
          initialized={onInitialized}
          height={350}
          // frozenColumns={4}
          autoCheck={false}
          isSelector={false}
          isFilter={false}
          allowPinning={false}
          isReadOnly={true}
        />
      </CustomDialog>
    </>
  );
};
export default MpMcrcPopUp;
